module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section03_03_beach-photo-62129fa600426fcae63480db3fde3fc2.jpg";